import * as actionTypes from 'src/app/state/actions/types';
import { getCurrentCartUUID } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';

export const fetchCheckoutPickupStations = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const state = getState();
    const { client } = state;
    const cartUUID = getCurrentCartUUID(state);

    dispatch({
      type: actionTypes.FETCH_CHECKOUT_PICKUP_STATIONS,
    });

    try {
      const checkoutPickupStations = await client.getPickupStations(cartUUID);
      const checkoutPickupStationsData = checkoutPickupStations.data;
      dispatch({
        type: actionTypes.FETCH_CHECKOUT_PICKUP_STATIONS_SUCCESS,
        payload: checkoutPickupStationsData,
      });
      // Anti Redux pattern but need it for a identify call for analytics.
      return checkoutPickupStationsData;
    } catch (err) {
      dispatch({
        type: actionTypes.FETCH_CHECKOUT_PICKUP_STATIONS_ERROR,
        error: err,
      });
    }
  };
};

export const clearCheckoutPickupStations = () => ({
  type: actionTypes.CLEAR_CHECKOUT_PICKUP_STATIONS,
});
